import request from './index'

/** 公开站点配置 */
export function fetchSiteConfig() {
  return request.get('/site/public.php')
}

/**
 * 站点日访问统计（公开接口，写入 fwrs/jfwrs 供运营后台统计）
 * @param {{ returning?: boolean }} payload
 */
export function trackSiteVisit(payload = {}) {
  return request.post('/site/visit.php', {
    returning: !!payload.returning
  }, { silent: true })
}
